module.exports = __webpack_public_path__ + "img/face-usecase-meme.38bccf9e.webp";